import { Component, OnInit, OnChanges } from '@angular/core';
import { Input } from '@angular/core';
import { ClickedAlarms } from './clicked-alarms';
import * as _ from 'lodash';

@Component({
    selector: 'app-alarms-popup',
    templateUrl: './alarms-popup.component.html',
    styleUrls: ['./alarms-popup.component.scss'],
    standalone: false
})
export class AlarmsPopupComponent implements OnChanges {

  @Input() logAlarms: any;
  public popupAlarms;
  public showAlarms;

  constructor(    private clickedAlarms: ClickedAlarms  ) { }

  ngOnChanges() {
    this.selectShowAlarms();
  }

  private selectShowAlarms() {
    this.showAlarms = false;
    this.popupAlarms = [];
    if (this.logAlarms) {
      this.logAlarms.alarms.forEach((element) => {
        const difference = Date.now() - element.createTS;
        const wasClicked = this.clickedAlarms.alarmList.filter(alarm => _.isEqual(element, alarm));
        if (difference < 86400000 && wasClicked.length === 0) {
          this.showAlarms = true;
          this.popupAlarms.push(element);
        }
      });
    }
    this.popupAlarms.sort(this.compare);
  }

  private compare(a, b) {
    if (a.createTS > b.createTS) {
      return -1;
    }
    if (a.createTS < b.createTS) {
      return 1;
    }
    return 0;
  }

  public gotoTurbine(alarm, index) {
    // Mark alarm as visited
    this.clickedAlarms.alarmList.push(this.popupAlarms[index]);
    this.showAlarms = false;
  }

  public closeAllAlarms() {
    this.popupAlarms.forEach(element => {
      this.clickedAlarms.alarmList.push(element);
    });
    this.showAlarms = false;
  }

  public closeSingleAlarm(index) {
    this.clickedAlarms.alarmList.push(this.popupAlarms[index]);
    this.selectShowAlarms();
  }
}
